// extracted by mini-css-extract-plugin
export var dropdownButton = "_35-0";
export var fullWidthDropdownButton = "_35-1";
export var icon = "_35-3";
export var iconPlaceholder = "_35-2";
export var menuItemRow = "_35-9";
export var separator = "_35-e";
export var shortcutContainer = "_35-7";
export var shortcutContainerFilled = "_35-8";
export var shortcutIconLg = "_35-6";
export var shortcutIconMd = "_35-5";
export var shortcutIconSm = "_35-4";
export var submenuChevron = "_35-d";
export var submenuDropdown = "_35-a";
export var submenuTriggerRow = "_35-b";
export var submenuTriggerRowOpen = "_35-c";